import React from "react"
import EmailBuilderActions from "./actions/EmailBuilderActions"
import ErrorHelper from "../Errors/ErrorHelper";

export default class EmailHeader extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      setOnce: false,
      focused: false,
      subject: this.props.email ? this.props.email.subject : '',
      from_address: this.props.email ? this.props.email.from_address : '',
      to_addresses: this.props.email ? this.props.email.to_addresses : '',
      cc_addresses: this.props.email ? this.props.email.cc_addresses : '',
      bcc_addresses: this.props.email ? this.props.email.bcc_addresses : '',
    }

    this.fromAddressRef = React.createRef();
    this.toAddressesRef = React.createRef();
    this.ccAddressesRef = React.createRef();
    this.bccAddressesRef = React.createRef();
    this.subjectRef = React.createRef()

    this.onChange = this.onChange.bind(this)
    this.getCaret = this.getCaret.bind(this)
    this.focusInput = this.focusInput.bind(this)
  }

  componentDidUpate() {
    if (this.props.email && !this.state.setOnce) {
      this.setState({
        setOnce: true,
        subject: this.props.email.subject,
        from_address: this.props.email.from_address,
        to_addresses: this.props.email.to_addresses,
        cc_addresses: this.props.email.cc_addresses,
        bcc_addresses: this.props.email.bcc_addresses,
      });

      $(this.fromAddressRef.current).val(this.props.email.from_address);
      $(this.toAddressesRef.current).val(this.props.email.to_addresses);
      $(this.ccAddressesRef.current).val(this.props.email.cc_addresses);
      $(this.bccAddressesRef.current).val(this.props.email.bcc_addresses);
      $(this.subjectRef.current).val(this.props.email.subject);
    }
  }

	render() {
		return (
        <div className="email-header">
  				<div className="to-cc-bcc-subject">
            <div className="row">
              <div className="col-sm-12">
                <div className="input-group">
                  <div className="input-group-addon">{I18n.t('from')}</div>
                  <input autoComplete="nope" type="text" name="email[from_address]" ref={this.fromAddressRef} data-ref="fromAddressRef" data-name="from_address" className='form-control' defaultValue={this.state.from_address} onFocus={this.focusInput} onKeyDown={this.getCaret} onKeyPress={this.getCaret} onMouseMove={this.getCaret} onChange={this.onChange.bind(null, 'from_address')} />
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-sm-12">
                <div className={ErrorHelper.renderFieldClasses('to_addresses', this.props.errors, 'input-group')}>
                  <div className="input-group-addon">{I18n.t('to')}</div>
                  <input autoComplete="nope" type="text" name="email[to_addresses]" ref={this.toAddressesRef} data-ref="toAddressesRef" data-name="to_addresses" className='form-control' defaultValue={this.state.to_addresses} onFocus={this.focusInput} onKeyDown={this.getCaret} onKeyPress={this.getCaret} onMouseMove={this.getCaret} onChange={this.onChange.bind(null, 'to_addresses')} />
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-sm-6">
                <div className="input-group">
                  <div className="input-group-addon">{I18n.t('cc')}</div>
                  <input autoComplete="nope" type="text" name="email[cc_addresses]" ref={this.ccAddressesRef} data-ref="ccAddressesRef" data-name="cc_addresses" className='form-control' defaultValue={this.state.cc_addresses} onFocus={this.focusInput} onKeyDown={this.getCaret} onKeyPress={this.getCaret} onMouseMove={this.getCaret} onChange={this.onChange.bind(null, 'cc_addresses')} />
                </div>
              </div>

              <div className="col-sm-6">
                <div className="input-group">
                  <div className="input-group-addon">{I18n.t('bcc')}</div>
                  <input autoComplete="nope" type="text" name="email[bcc_addresses]" ref={this.bccAddressesRef} data-ref="bccAddressesRef" data-name="bcc_addresses" className='form-control' defaultValue={this.state.bcc_addresses} onFocus={this.focusInput} onKeyDown={this.getCaret} onKeyPress={this.getCaret} onMouseMove={this.getCaret} onChange={this.onChange.bind(null, 'bcc_addresses')} />
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-sm-12">
                <div className={ErrorHelper.renderFieldClasses('subject', this.props.errors, 'input-group')}>
                  <div className="input-group-addon">{I18n.t('subject')}</div>
                  <input autoComplete="nope" type="text" name="email[subject]" ref={this.subjectRef} data-ref="subjectRef" className='form-control' defaultValue={this.state.subject} data-name="subject" onFocus={this.focusInput} onKeyDown={this.getCaret} onKeyPress={this.getCaret} onMouseMove={this.getCaret} onChange={this.onChange.bind(null, 'subject')} />
                </div>
              </div>
            </div>
          </div>
  			</div>
		);
	}

  focusInput(event) {
    EmailBuilderActions.focusInput($(event.target).data('name'));
  }

  getCaret(event) {
    var name = $(event.target).data('ref');
    
    if (typeof name == 'undefined' || name != this.props.focusedInput) {
      return;
    }

    var caretPos = $(this[name].current).caret();

    EmailBuilderActions.setCaretPosition(caretPos);
  }

  onChange(name, event) {
    var state = this.state;
    state[name] = event.target.value;
    this.setState(state);

    EmailBuilderActions.setEmail(name, event.target.value);
  }

};
